import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "ef1gE7AqR8x1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 236 178",
  "shape-rendering": "geometricPrecision",
  "text-rendering": "geometricPrecision"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("g", {
  id: "ef1gE7AqR8x2",
  "clip-path": "url(#ef1gE7AqR8x144)"
}, [
  /*#__PURE__*/_createVNode("g", { id: "ef1gE7AqR8x3" }, [
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x4",
      d: "M207.375,69.7837C197.856,60.5906,186.382,5.16788,147.067,34.0382C126.752,48.9525,92.4923,21.2363,64.1493,30.801C38.1109,39.5931,35.6029,68.5612,38.1206,77.9988C43.214,97.0696,27.3721,99.9058,12.6825,108.092C-10.3637,120.942,6.58207,166.096,28.3501,166.311C50.1182,166.526,182.005,165.881,182.005,165.881C182.005,165.881,213.63,165.969,226.78,146.223C240.928,124.972,231.961,93.5195,207.375,69.7837Z",
      opacity: "0.1007",
      fill: "rgb(67,96,168)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x5",
      d: "M139.379,149.992C141.322,146.01,144.515,142.724,147.986,140.039C150.809,137.863,154.002,135.779,157.333,134.53C160.295,133.418,160.943,136.011,163.349,136.891C164.876,137.446,166.588,136.613,167.791,135.502C168.948,134.437,169.92,133.094,171.308,132.307C172.326,131.706,173.853,131.428,174.918,132.076C176.26,132.863,176.028,134.761,177.833,134.992C178.666,135.085,179.499,134.807,180.239,134.437C181.998,133.557,183.802,132.77,185.7,132.215C187.412,131.706,189.679,131.52,190.651,133.048C191.623,134.483,190.697,136.428,189.54,137.724C186.764,140.825,182.692,142.492,178.573,143.048C177.463,143.186,176.306,143.279,175.242,143.742C174.224,144.205,173.298,145.131,173.252,146.288C173.252,146.89,173.437,147.492,173.483,148.094C173.483,149.807,171.817,151.056,170.198,151.427C165.94,152.399,163.164,148.649,159.184,148.094C154.649,147.446,147.708,148.14,144.562,151.982",
      fill: "rgb(176,238,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x6",
      d: "M146.829,148.14C151.225,144.066,157.009,141.335,163.071,140.548C166.866,140.039,170.707,140.27,174.501,139.946C178.296,139.622,182.229,138.557,184.959,136.058",
      opacity: "0.5",
      fill: "none",
      stroke: "rgb(255,255,255)",
      "stroke-width": "0.891",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x7",
      d: "M166.681,131.289C168.948,129.993,171.355,128.141,170.753,125.363C170.522,124.438,169.874,123.604,169.966,122.678C170.059,122.077,170.429,121.567,170.753,121.012C171.447,119.716,171.54,118.142,171.031,116.753C170.429,115.271,169.226,114.207,168.439,112.818C167.792,111.707,167.514,110.41,167.56,109.114C165.154,109.346,163.118,110.873,160.804,111.522C159.046,112.031,157.148,112.031,155.39,112.586C152.197,113.651,149.791,116.753,149.606,120.086C148.079,119.947,146.505,120.641,145.534,121.891C144.515,123.188,144.053,124.947,144.284,126.521C145.348,133.233,148.773,138.603,153.215,143.603C152.243,142.538,155.205,139.159,155.76,138.465C158.259,135.594,161.637,133.974,164.923,132.169C165.478,131.937,166.033,131.613,166.681,131.289Z",
      fill: "rgb(176,238,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("g", {
      id: "ef1gE7AqR8x8",
      opacity: "0.5"
    }, [
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x9",
        d: "M153.77,134.623C153.215,131.752,153.955,128.743,154.881,125.966C155.76,123.234,156.871,120.549,158.398,118.142C159.971,115.735,162.007,113.605,164.552,112.263",
        opacity: "0.5",
        fill: "none",
        stroke: "rgb(255,255,255)",
        "stroke-width": "0.891",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "10"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x10",
        d: "M154.511,114.994C154.465,117.633,154.927,120.735,155.853,123.188",
        opacity: "0.5",
        fill: "none",
        stroke: "rgb(255,255,255)",
        "stroke-width": "0.891",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "10"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x11",
        d: "M156.27,122.216C159.046,120.04,163.535,118.466,167.051,118.327",
        opacity: "0.5",
        fill: "none",
        stroke: "rgb(255,255,255)",
        "stroke-width": "0.891",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "10"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x12",
        d: "M149.051,123.373C152.753,124.53,153.401,129.808,153.632,131.289",
        opacity: "0.5",
        fill: "none",
        stroke: "rgb(255,255,255)",
        "stroke-width": "0.891",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "10"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x13",
        d: "M154.279,127.863C156.824,125.641,161.22,123.28,164.182,123.743",
        opacity: "0.5",
        fill: "none",
        stroke: "rgb(255,255,255)",
        "stroke-width": "0.891",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "10"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x14",
        d: "M153.725,134.345C155.761,131.66,161.267,128.327,164.275,128.79",
        opacity: "0.5",
        fill: "none",
        stroke: "rgb(255,255,255)",
        "stroke-width": "0.891",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "10"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x15",
        d: "M160.434,113.096C159.694,114.207,159.601,115.41,159.786,116.244",
        opacity: "0.5",
        fill: "none",
        stroke: "rgb(255,255,255)",
        "stroke-width": "0.891",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "10"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x16",
        d: "M160.48,115.411C161.684,114.67,163.349,114.346,165.2,114.624",
        opacity: "0.5",
        fill: "none",
        stroke: "rgb(255,255,255)",
        "stroke-width": "0.891",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "10"
      })
    ]),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x17",
      d: "M69.695,156.731C66.6409,148.352,58.7742,140.528,51.0464,136.037C49.1491,134.926,46.4189,134.139,45.5397,136.732C44.9844,138.398,43.0409,137.982,41.9303,137.195C40.542,136.222,39.7554,134.695,38.5985,133.491C37.673,132.565,36.4699,131.825,35.1279,131.639C33.8322,131.408,32.3977,131.778,31.426,132.704C30.6856,133.399,30.2691,134.371,29.4362,134.973C28.0942,135.991,26.1044,135.621,24.6699,134.741C23.2354,133.862,22.0785,132.565,20.6903,131.593C19.302,130.621,17.4048,130.065,15.924,130.899C13.9342,131.963,13.7491,134.834,14.6283,136.917C15.1373,138.213,15.9703,140.065,16.942,141.083C18.3303,142.518,20.3664,143.444,22.3099,143.861C23.7444,144.139,25.2252,144.139,26.6134,144.463C27.1224,144.602,27.724,144.787,27.8166,145.389C27.9554,146.222,26.8911,146.778,26.2895,147.055C25.2252,147.611,24.1609,148.768,24.6699,149.833C24.9938,150.527,25.7805,150.805,26.5209,150.944C28.742,151.314,30.9169,150.666,33.0456,150.018C34.3413,149.601,35.4518,148.814,36.7475,148.49C37.4417,148.305,39.1538,148.259,38.9687,149.37C38.9224,149.74,38.6448,150.018,38.3671,150.25C38.0895,150.481,37.7656,150.712,37.5342,150.99C36.5162,152.194,37.5342,153.675,38.8299,153.999C39.8479,154.231,40.9122,153.999,41.9303,153.768C48.5938,152.194,55.5813,151.592,62.2448,152.981C63.6793,153.259,65.2526,153.768,65.9467,155.018",
      fill: "rgb(176,238,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x18",
      d: "M62.5227,151.453C57.6176,146.917,51.1392,143.954,44.3831,143.074C40.1722,142.565,35.8686,142.843,31.6576,142.472C27.4004,142.102,23.0043,140.991,19.9502,138.167",
      opacity: "0.5",
      fill: "none",
      stroke: "rgb(255,255,255)",
      "stroke-width": "0.891",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x19",
      d: "M64.0498,152.101C64.0498,152.101,52.4349,144.37,49.1494,136.5C51.3706,137.102,52.8051,137.843,54.3784,139.092C56.0443,141.453,60.0702,145.111,62.8004,147.472C63.1243,148.768,63.5408,150.296,64.0498,152.101Z",
      opacity: "0.25",
      fill: "rgb(252,204,177)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x20",
      d: "M63.5872,149.416C63.1708,146.685,61.9676,143.954,61.4586,141.176C60.7182,136.732,60.5794,132.241,61.4123,127.797C62.1064,124.001,63.2633,120.066,62.0139,116.27C61.69,115.251,61.0421,114.14,59.7465,114.187C59.2374,114.187,58.7284,114.418,58.3582,114.742C57.3865,115.575,57.2014,116.825,57.0625,117.983L56.5535,121.871C56.3684,123.121,54.4712,123.307,54.0547,122.057C54.0547,122.057,54.0547,122.057,54.0547,122.01C53.7308,120.992,53.777,119.881,53.8696,118.816C54.0547,116.501,54.3323,114.14,54.0084,111.826C53.5919,109.002,52.0186,106.178,49.057,105.113C47.9927,104.743,46.8359,104.696,45.7253,105.02C42.7174,105.9,42.1159,108.724,42.7174,111.085C43.1339,112.751,44.0594,114.279,44.9386,115.807C47.021,119.51,45.9104,123.029,46.4194,127.195C47.4837,135.991,56.0908,144.463,63.5872,149.416Z",
      fill: "rgb(176,238,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x21",
      d: "M47.1602,110.112C53.4535,117.704,51.186,135.713,62.1531,145.388",
      opacity: "0.5",
      fill: "none",
      stroke: "rgb(255,255,255)",
      "stroke-width": "0.891",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x22",
      d: "M59.4221,119.048C60.1625,122.89,57.6637,127.196,57.1084,129.603C56.5531,132.01,56.2292,136.084,56.8308,138.491",
      opacity: "0.5",
      fill: "none",
      stroke: "rgb(255,255,255)",
      "stroke-width": "0.891",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x23",
      d: "M45.8582,154.298C45.5806,152.77,41.277,143.187,36.3257,145.734C33.3641,147.261,33.9194,152.863,38.5006,157.122C37.5751,156.242,36.557,155.27,35.3076,154.992C34.6598,154.854,33.8268,155.178,33.3178,155.641C32.8551,156.057,32.7625,156.705,32.7162,157.307C32.6237,159.529,33.7806,161.705,35.6315,162.909C34.6135,162.353,33.7343,161.612,32.5774,161.52C32.2072,161.474,31.5594,161.705,31.3743,162.029C31.1892,162.399,31.1892,163.788,33.4566,164.807C24.2943,163.048,23.7853,166.983,27.0708,166.983C30.3562,166.983,54.0488,166.983,54.0488,166.983",
      fill: "rgb(233,249,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x24",
      d: "M76.9393,141.557C76.2979,138.423,69.7242,118.78,58.18,123.971C51.3389,127.058,52.5682,138.517,63.2573,147.122C61.1729,145.345,58.7144,143.334,55.8284,142.819C54.2784,142.539,52.3544,143.194,51.232,144.129C50.2166,144.971,49.8959,146.28,49.8425,147.496C49.6821,151.986,52.3544,156.476,56.63,158.908C54.2784,157.739,52.1941,156.289,49.5218,156.102C48.6667,156.055,47.1702,156.476,46.7426,157.178C46.3151,157.926,46.3151,160.732,51.5527,162.79C30.2814,159.236,29.0522,167.187,36.6949,167.187C44.3376,167.187,87.2543,167.187,87.2543,167.187",
      fill: "rgb(215,246,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x25",
      d: "M169.457,154.761C169.735,153.233,174.038,143.65,178.99,146.197C181.951,147.724,181.396,153.326,176.815,157.585C177.74,156.705,178.758,155.733,180.008,155.455C180.656,155.316,181.489,155.64,181.998,156.103C182.46,156.52,182.553,157.168,182.599,157.77C182.692,159.992,181.535,162.168,179.684,163.372C180.702,162.816,181.581,162.075,182.738,161.983C183.108,161.936,183.756,162.168,183.941,162.492C184.126,162.862,184.126,164.251,181.859,165.27C191.021,163.51,191.53,167.445,188.245,167.445C184.959,167.445,161.267,167.445,161.267,167.445",
      fill: "rgb(233,249,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x26",
      d: "M152.336,147.168C152.753,144.715,157.288,129.206,165.247,133.326C169.967,135.78,169.134,144.761,161.73,151.566C163.164,150.177,164.83,148.557,166.82,148.187C167.884,147.955,169.18,148.464,170.013,149.205C170.707,149.853,170.939,150.918,170.985,151.89C171.124,155.408,169.273,158.927,166.311,160.871C167.931,159.945,169.365,158.834,171.216,158.649C171.818,158.603,172.836,158.927,173.113,159.482C173.437,160.084,173.391,162.26,169.782,163.927C184.451,161.149,185.284,167.399,180.008,167.399C174.733,167.399,145.21,167.399,145.21,167.399",
      fill: "rgb(215,246,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x27",
      d: "M196.158,168.256C211.229,168.256,223.446,167.212,223.446,165.925C223.446,164.637,211.229,163.594,196.158,163.594C181.087,163.594,168.869,164.637,168.869,165.925C168.869,167.212,181.087,168.256,196.158,168.256Z",
      fill: "rgb(230,236,239)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x28",
      d: "M195.576,84.8321C195.755,85.8632,195.8,86.9839,195.71,88.1045L195.307,88.1942L194.993,88.1942L194.679,87.8356L194.545,85.639L194.948,84.339L197.906,82.277L198.398,82.0977L195.576,84.8321Z",
      fill: "rgb(255,189,29)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x29",
      d: "M198.309,90.9733L197.099,93.7974L193.649,93.7974L193.246,93.7974C192.618,94.6939,191.901,95.456,191.095,96.1284L191.229,100.253L188.361,101.418L185.763,98.7733L185.673,98.6836C184.642,98.8629,183.567,98.9077,182.447,98.8181L179.624,101.822L176.935,100.701L176.756,100.611L176.756,96.756C175.86,96.1284,175.098,95.4112,174.381,94.6043L170.348,94.7388L170.259,94.7388L169.094,91.8698L171.827,89.1802C171.648,88.1491,171.603,87.0284,171.693,85.9526L168.69,83.1733L169.9,80.3043L173.754,80.3043C174.336,79.4526,175.053,78.6457,175.86,77.9733L175.86,77.8836L175.77,73.8043L178.638,72.6388L181.326,75.3733C182.357,75.194,183.388,75.1491,184.508,75.2388L184.777,74.9698L187.376,72.2354L187.42,72.2354L190.243,73.4009L190.243,77.256C191.14,77.8836,191.901,78.6009,192.618,79.4078L196.741,79.2733L197.906,82.1422L195.172,84.8319C195.352,85.8629,195.396,86.9388,195.307,88.0595L198.309,90.9733Z",
      fill: "rgb(253,207,51)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x30",
      d: "M193.781,88.4151C194.495,82.6659,190.415,77.4261,184.668,76.7118C178.921,75.9975,173.684,80.0791,172.97,85.8284C172.256,91.5776,176.335,96.8173,182.082,97.5317C187.829,98.246,193.067,94.1643,193.781,88.4151Z",
      opacity: "0.3",
      fill: "rgb(253,207,51)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x31",
      d: "M191.536,87.8584C192.082,83.4605,188.961,79.4523,184.565,78.9059C180.169,78.3594,176.162,81.4817,175.616,85.8796C175.07,90.2776,178.191,94.2857,182.587,94.8321C186.983,95.3786,190.989,92.2563,191.536,87.8584Z",
      fill: "rgb(255,250,228)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x32",
      d: "M183.566,78.8252L183.566,79.8562",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x33",
      d: "M177.876,81.2461L178.593,81.9633",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x34",
      d: "M175.546,87.0283L176.577,87.0283",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x35",
      d: "M177.966,92.767L178.728,92.0049",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x36",
      d: "M183.746,95.0974L183.746,94.0664",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x37",
      d: "M189.482,92.6323L188.765,91.915",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x38",
      d: "M190.646,86.8496L191.677,86.8496",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x39",
      d: "M189.302,81.2012L188.585,81.9184",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x40",
      d: "M180.475,79.4082L180.699,79.991",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x41",
      d: "M176.039,83.8018L176.622,84.0259",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x42",
      d: "M175.994,90.0326L176.577,89.7637",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x43",
      d: "M180.386,94.4705L180.655,93.8877",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x44",
      d: "M186.614,94.4705L186.39,93.8877",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x45",
      d: "M191.05,90.1215L190.468,89.8525",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x46",
      d: "M191.094,83.8457L190.512,84.1147",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x47",
      d: "M186.703,79.4521L186.435,80.0349",
      fill: "none",
      stroke: "rgb(228,159,5)",
      "stroke-width": "0.3564",
      "stroke-miterlimit": "10"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x48",
      d: "M183.567,87.4769C183.913,87.4769,184.194,87.1959,184.194,86.8493C184.194,86.5027,183.913,86.2217,183.567,86.2217C183.22,86.2217,182.939,86.5027,182.939,86.8493C182.939,87.1959,183.22,87.4769,183.567,87.4769Z",
      fill: "rgb(140,198,75)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x49",
      d: "M184.239,87.1179C184.239,87.5662,183.88,87.88,183.477,87.88C183.432,87.88,183.388,87.88,183.388,87.88L181.282,91.4662L180.161,91.9593C179.982,92.0489,179.848,91.9144,179.848,91.7351L180.072,90.5248L183.029,87.7455C182.805,87.611,182.715,87.4317,182.715,87.1627C182.715,86.7593,183.029,86.4007,183.432,86.4007L182.939,82.5007L183.298,81.5593C183.343,81.38,183.567,81.38,183.656,81.5593L184.06,82.4558L183.701,86.3558C184.015,86.3558,184.239,86.7144,184.239,87.1179Z",
      opacity: "0.3",
      fill: "rgb(61,61,61)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x50",
      d: "M183.433,81.5144L183.164,82.2764C183.164,82.3213,183.164,82.3213,183.164,82.3661L183.657,86.3109L184.105,82.3213C184.105,82.2764,184.105,82.2764,184.105,82.2316L183.791,81.5144C183.702,81.3351,183.478,81.3351,183.433,81.5144Z",
      fill: "rgb(253,207,51)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x51",
      d: "M179.937,91.691L180.878,91.2875C180.923,91.2875,180.968,91.2427,180.968,91.1979L183.253,87.2979L179.892,90.3461C179.847,90.391,179.847,90.4358,179.847,90.4806L179.668,91.5117C179.623,91.6013,179.803,91.7358,179.937,91.691Z",
      fill: "rgb(253,207,51)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x52",
      d: "M183.611,87.7009C184.032,87.7009,184.373,87.3597,184.373,86.9388C184.373,86.518,184.032,86.1768,183.611,86.1768C183.191,86.1768,182.85,86.518,182.85,86.9388C182.85,87.3597,183.191,87.7009,183.611,87.7009Z",
      fill: "rgb(228,159,5)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x53",
      d: "M183.612,87.6114C183.983,87.6114,184.284,87.3104,184.284,86.939C184.284,86.5677,183.983,86.2666,183.612,86.2666C183.24,86.2666,182.939,86.5677,182.939,86.939C182.939,87.3104,183.24,87.6114,183.612,87.6114Z",
      fill: "rgb(253,207,51)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x54",
      d: "M194.232,75.8662C194.232,75.8662,189.976,76.0007,192.216,80.8421C194.501,85.6835,194.232,75.8662,194.232,75.8662Z",
      fill: "rgb(46,59,97)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x55",
      d: "M193.067,77.6141C193.067,77.6141,191.902,78.3313,191.947,82.0969C191.947,82.2313,191.498,83.352,191.454,83.4865C191.274,83.9796,191.633,84.0244,192.036,84.2486C192.215,87.1175,192.663,87.0727,193.022,87.2969C193.47,87.5658,196.741,86.8934,198.847,85.8624C200.953,84.8313,201.67,81.6934,200.774,79.7658C199.878,77.8831,195.531,75.9555,193.067,77.6141Z",
      fill: "rgb(255,178,125)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x56",
      d: "M202.567,80.3042C202.925,82.0973,202.029,84.8766,198.489,86.0421C198.489,86.0421,198.175,84.9663,197.951,83.8904C197.727,82.8145,194.725,81.6042,193.426,80.4387C193.381,80.3938,193.291,80.3042,193.246,80.2594C192.305,79.2731,192.35,77.749,193.201,76.718C193.918,75.8214,195.532,74.3421,198.399,75.3283C200.998,76.2249,202.163,78.1076,202.567,80.3042Z",
      fill: "rgb(46,59,97)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x57",
      d: "M194.053,84.3383C194.591,84.921,194.725,86.1762,194.68,87.2969C194.68,87.4762,194.635,87.7003,194.635,87.8796C194.546,89.09,194.322,90.0762,194.322,90.0762L198.399,89.9865C198.265,88.5072,198.489,86.0865,198.489,86.0865C198.489,86.0865,192.753,82.9038,194.053,84.3383Z",
      fill: "rgb(255,178,125)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x58",
      d: "M194.635,87.88C196.158,87.3421,197.323,86.5352,197.323,86.5352C196.203,86.8938,194.68,87.2972,194.68,87.2972C194.68,87.4765,194.635,87.7007,194.635,87.88Z",
      fill: "rgb(242,161,129)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x59",
      d: "M191.723,116.749L198.086,109.891C198.086,109.891,201.939,113.97,201.222,118.453C200.864,120.649,200.236,121.815,200.012,122.846C199.833,123.832,199.295,137.415,199.609,138.401C199.878,139.342,201.357,141.942,202.163,144.766C203.104,148.173,204.09,153.06,204.852,155.973C205.613,158.887,204.359,162.832,204.09,161.846C201.76,153.373,195.576,143.646,194.59,139.387C193.56,135.129,192.798,127.194,191.723,116.749Z",
      fill: "rgb(255,190,157)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x60",
      d: "M202.163,155.659C202.163,155.659,204.135,161.218,203.955,161.89C203.866,162.338,203.418,163.773,203.328,163.952C203.283,164.042,201.894,165.163,202.835,165.118C203.731,165.073,205.927,162.204,206.241,161.98C206.778,161.621,207.002,161.038,206.868,160.545C206.689,159.694,206.106,159.021,205.703,158.438C205.3,157.856,204.941,156.152,204.941,156.152L202.163,155.659Z",
      fill: "rgb(255,178,125)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x61",
      d: "M201.58,165.432C201.939,164.894,203.104,164.222,203.104,164.222C203.283,163.998,203.417,163.863,203.328,163.998C203.193,164.222,203.821,164.356,204.134,164.087C205.21,163.236,205.523,161.936,206.016,161.353C206.778,160.501,206.24,159.336,206.151,159.156C206.375,159.156,207.405,159.649,207.674,159.829C207.898,160.008,208.391,160.456,208.481,160.725C208.57,160.905,208.929,161.936,209.198,162.384L208.167,163.191L207.181,162.294C207.181,162.294,207.181,162.294,206.913,162.563C206.644,162.832,206.42,163.325,206.375,163.639C206.375,163.773,206.24,164.087,206.106,164.446C205.972,164.849,205.703,165.208,205.344,165.477C205.344,165.477,205.12,165.656,204.896,165.836C204.582,166.105,204.179,166.239,203.776,166.239L202.028,166.239L201.759,166.239C201.491,166.239,201.267,166.015,201.311,165.746C201.446,165.701,201.491,165.567,201.58,165.432Z",
      fill: "rgb(31,58,113)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x62",
      d: "M186.883,164.58C187.017,164.4,188.63,163.997,189.392,163.594C190.109,163.235,190.916,162.159,191.05,161.711C191.184,161.262,190.96,159.156,190.871,158.259C190.154,152.118,188.003,143.511,187.51,139.925C186.659,133.694,186.883,127.149,188.406,116.883L196.741,109.173C196.741,109.173,199.653,113.611,199.25,118.183C198.981,120.828,196.875,121.411,196.606,122.442C196.337,123.473,192.349,140.238,192.349,140.238C192.349,140.238,193.739,143.645,194.142,147.5C194.5,150.773,193.559,154.494,193.649,158.259C193.694,159.021,193.694,160.769,193.963,161.307C194.276,161.98,195.038,162.742,195.083,163.594C195.128,164.087,194.769,164.625,194.187,164.849C193.559,165.118,193.201,164.759,192.977,164.759C191.722,164.804,191.453,165.7,189.258,165.925C188.586,165.969,187.555,165.7,187.017,165.207C186.704,165.028,186.748,164.759,186.883,164.58Z",
      fill: "rgb(255,178,125)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x63",
      d: "M186.748,165.341C186.838,165.476,186.972,165.655,187.196,165.834C187.6,166.148,188.092,166.283,188.585,166.283L189.661,166.283C190.109,166.283,190.512,166.148,190.915,165.969C191.229,165.79,191.498,165.61,191.588,165.521C191.812,165.341,192.26,165.072,192.663,165.028C193.066,164.983,193.335,165.028,193.335,165.028L193.425,166.328L194.903,166.328C194.859,165.879,195.217,164.669,195.262,164.49C195.351,164.176,195.217,163.638,195.172,163.369C195.083,163.055,194.41,162.024,194.231,161.89C194.186,162.069,193.873,163.279,192.753,163.503C191.946,163.638,190.915,164.445,189.571,164.4C189.168,164.4,188.765,163.907,189.033,163.817C189.257,163.728,188.585,163.817,188.182,163.997C187.734,164.131,187.017,164.579,186.793,164.669C186.614,164.714,186.614,165.072,186.748,165.341Z",
      fill: "rgb(31,58,113)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x64",
      d: "M204.986,100.432C204.986,100.432,204.538,102.629,204.269,103.525C204,104.422,202.656,110.205,201.401,110.115C200.147,110.025,193.246,104.243,193.246,104.243L194.232,102.27L200.326,105.184C200.326,105.184,200.864,98.5944,201.357,97.0254L204.986,100.432Z",
      fill: "rgb(255,178,125)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x65",
      d: "M203.238,100.656C202.611,102.942,201.356,106.439,200.863,107.111C200.639,107.425,196.562,105.945,196.562,104.332L200.774,99.5352L203.238,100.656Z",
      fill: "rgb(242,161,129)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x66",
      d: "M199.385,90.0771C199.385,90.0771,201.491,90.122,203.059,91.3323C205.703,93.3047,205.075,100.701,205.075,100.701C205.075,100.701,205.21,101.105,203.462,100.97C201.715,100.881,200.326,100.387,200.326,100.387L200.819,94.4702L199.385,90.0771Z",
      fill: "rgb(255,255,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x67",
      d: "M203.776,94.5596C203.776,94.5596,204,98.8182,203.239,100.97C202.477,100.97,201.805,100.791,201.805,100.791L203.776,94.5596Z",
      fill: "rgb(235,243,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x68",
      d: "M199.475,90.4801C199.385,89.987,199.251,89.4491,198.803,89.225C198.668,89.1801,198.534,89.1353,198.399,89.1353C197.01,89.0008,197.189,88.9112,195.8,88.956C195.218,88.956,194.635,89.0008,194.142,89.2698C193.336,89.6732,192.888,90.525,192.529,91.3319L199.475,90.4801Z",
      fill: "rgb(56,159,229)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x69",
      d: "M199.475,90.4801C199.385,89.987,199.251,89.4491,198.803,89.225C198.668,89.1801,198.534,89.1353,198.399,89.1353C197.01,89.0008,197.189,88.9112,195.8,88.956C195.218,88.956,194.635,89.0008,194.142,89.2698C193.336,89.6732,192.888,90.525,192.529,91.3319L199.475,90.4801Z",
      fill: "rgb(56,159,229)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x70",
      d: "M204.896,155.301C204.358,152.925,202.969,146.829,201.983,144.229C200.997,141.629,199.653,138.849,199.608,138.401C199.563,138.042,199.922,135.442,200.056,134.591L200.056,134.546C200.056,134.232,201.49,123.473,201.938,121.815C202.118,121.232,202.969,119.26,202.79,116.301C202.61,113.342,200.28,109.801,199.653,109.173L188.765,108.994C188.765,108.994,186.883,113.432,186.703,116.167C186.345,121.949,186.883,134.098,186.883,134.098C186.883,134.098,186.883,134.098,186.927,134.098C186.927,134.949,187.017,137.011,187.286,138.849C187.599,141.225,190.96,160.815,190.96,160.815C190.96,160.815,192.618,161.084,193.918,160.501C193.918,160.501,193.873,160.277,193.873,160.098C193.738,157.722,194.814,150.236,193.873,145.618C192.932,141.001,192.528,140.015,192.528,140.015L193.559,134.994C193.559,134.904,193.604,134.725,193.604,134.725C193.738,135.891,194.007,138.267,194.366,139.522C194.859,141.36,199.608,151.67,201.49,156.108C202.118,157.632,202.7,159.335,202.7,159.335C202.7,159.335,204.985,159.067,205.613,158.08C205.702,158.08,205.389,157.408,204.896,155.301Z",
      fill: "rgb(28,70,138)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x71",
      d: "M188.989,107.246C189.392,106.484,189.706,103.346,189.572,102.539C189.437,101.687,188.676,101.194,188.317,99.2666C187.869,96.8011,188.9,94.8735,189.437,94.0218C190.244,92.8563,191.364,90.4804,191.588,90.4356C194.949,89.4045,195.486,89.8976,197.772,89.9873C198.892,90.0321,199.609,90.077,200.684,90.3459C201.894,90.6149,203.373,91.0183,203.597,92.677C204,95.2321,203.642,97.7873,202.88,100.208C202.387,101.822,199.295,107.336,200.057,108.411C200.236,108.636,200.684,109.129,200.729,109.442C200.908,110.563,199.116,110.832,197.324,111.056C195.666,111.236,193.963,111.146,192.126,111.011C187.018,110.653,188.81,107.56,188.989,107.246Z",
      fill: "rgb(255,255,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x72",
      d: "M203.104,93.9315C201.177,95.097,198.802,94.9625,197.144,94.6487C197.234,93.3487,197.099,90.6142,197.099,90.6142C197.099,91.6004,196.651,93.9315,196.562,94.5142C195.71,94.3349,195.128,94.1108,195.128,94.1108C195.128,94.1108,196.427,87.7453,196.427,84.9211C196.427,82.5004,193.873,80.8418,193.873,80.8418L198.175,75.2832C198.175,75.2832,201.58,76.2246,202.521,80.3487C203.059,82.366,203.104,93.9315,203.104,93.9315Z",
      fill: "rgb(46,59,97)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x73",
      d: "M199.071,118.812C198.937,119.349,198.534,120.784,197.503,122.129L193.829,135.936C193.829,135.936,193.739,135.353,193.694,134.68C194.904,129.66,196.383,123.025,196.562,122.398C196.831,121.456,198.578,120.874,199.071,118.812Z",
      opacity: "0.35",
      fill: "rgb(82,117,160)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x74",
      d: "M190.288,98.638C190.288,98.638,185.225,106.752,183.432,106.752C182.133,106.752,174.829,98.0553,174.829,98.0553L177.294,97.3828L183.253,101.507L186.883,95.5449L190.288,98.638Z",
      fill: "rgb(255,178,125)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x75",
      d: "M171.962,95.0073C171.962,94.8728,171.962,94.6935,171.962,94.5591C171.917,94.2453,171.693,93.9315,171.603,93.6177C171.558,93.3487,171.558,93.0797,171.558,92.8556C171.558,92.5418,171.379,92.0487,171.603,92.0487C171.558,91.8694,171.469,91.6453,171.424,91.4659C171.379,91.3315,171.424,91.0625,171.558,91.0625C171.782,91.1073,172.096,91.4211,172.231,91.5556C172.455,91.7797,172.768,92.2728,172.948,92.497C173.351,92.9901,173.844,93.2142,173.844,93.2142C173.844,93.2142,173.709,92.9901,173.799,92.9004C173.933,92.7211,174.381,93.0349,174.874,93.0797C175.143,93.1246,175.77,93.8866,175.95,94.1108C176.174,94.3349,176.353,95.6797,176.398,95.9487C176.532,96.6659,177.473,97.5177,177.473,97.5177L175.367,98.5487C175.322,98.5935,175.098,98.2797,175.054,98.2349C174.919,98.1004,174.74,97.9211,174.561,97.8315C173.889,97.2039,172.948,96.8901,172.365,96.128C172.186,95.859,172.007,95.4556,171.962,95.0073C171.962,95.0522,171.962,95.0073,171.962,95.0073Z",
      fill: "rgb(255,178,125)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x76",
      d: "M173.843,93.2144C174.157,93.573,174.471,93.6178,174.784,93.7523C175.008,93.8868,175.008,93.9764,175.277,94.1109C174.919,94.2006,174.919,93.9764,174.381,93.7523C174.112,93.6626,173.843,93.573,173.754,93.304C173.664,93.2592,173.799,93.1695,173.843,93.2144Z",
      fill: "rgb(242,161,129)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x77",
      d: "M194.724,89.7627C193.649,89.8075,190.199,90.0765,188.093,93.1696C186.928,94.9179,185.628,96.9799,185.001,98.5937C185.27,99.5351,187.107,101.508,188.765,101.508C188.855,101.463,191.319,98.4144,191.767,95.9937L194.724,89.7627Z",
      fill: "rgb(255,255,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x78",
      d: "M206.016,75.3732L203.686,76.6284L204.851,73.5801",
      fill: "rgb(207,239,254)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x79",
      d: "M208.346,76.4937C211.093,76.4937,213.32,74.2659,213.32,71.5178C213.32,68.7698,211.093,66.542,208.346,66.542C205.599,66.542,203.372,68.7698,203.372,71.5178C203.372,74.2659,205.599,76.4937,208.346,76.4937Z",
      fill: "rgb(207,239,254)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x80",
      d: "M208.614,68.6941C207.629,68.6044,206.732,69.3665,206.643,70.3527C206.598,70.6217,206.688,70.9355,206.777,71.2044L206.957,71.6527L207.584,73.2217L208.211,73.2665L208.838,73.3113L209.69,71.8768L209.959,71.4734C210.138,71.2044,210.228,70.9355,210.272,70.6217C210.362,69.6803,209.6,68.7837,208.614,68.6941ZM208.659,68.4251C209.824,68.5148,210.676,69.5458,210.586,70.7113C210.541,71.0699,210.407,71.3837,210.228,71.6527L209.018,73.6251L208.211,73.5355L207.405,73.4458L206.553,71.2941C206.419,70.9803,206.374,70.6665,206.374,70.3079C206.464,69.1423,207.494,68.2906,208.659,68.4251Z",
      fill: "rgb(103,194,239)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x81",
      d: "M208.032,75.1043C208.48,75.1491,208.883,74.7905,208.928,74.3422L208.973,73.7595L207.36,73.625L207.315,74.2078C207.27,74.656,207.584,75.0595,208.032,75.1043Z",
      fill: "rgb(103,194,239)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x82",
      d: "M209.331,70.9805C209.421,70.9805,209.466,70.9357,209.466,70.846C209.466,70.7564,209.421,70.7115,209.331,70.7115L207.539,70.5322C207.449,70.5322,207.404,70.5771,207.404,70.6667C207.404,70.7564,207.449,70.8012,207.539,70.8012L209.331,70.9805Z",
      fill: "rgb(103,194,239)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x83",
      d: "M208.212,73.5359C208.301,73.5359,208.346,73.491,208.346,73.4014L208.57,70.7566C208.57,70.6669,208.525,70.6221,208.436,70.6221C208.346,70.6221,208.301,70.6669,208.301,70.7566L208.077,73.4014C208.077,73.4462,208.122,73.5359,208.212,73.5359Z",
      fill: "rgb(103,194,239)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x84",
      d: "M86.452,11.3555C86.0058,11.534,85.6935,11.9358,85.6042,12.4268C85.515,12.8732,85.6935,13.4089,86.0505,13.7214C85.6489,13.7214,85.3811,14.2124,85.4257,14.6142C85.4704,15.016,85.7381,15.3731,86.0058,15.6409C86.3182,15.9981,86.7198,16.3105,87.166,16.3105C87.523,16.3105,87.8353,16.132,88.0584,15.9088C88.2369,15.7302,88.3708,15.5517,88.46,15.3285C88.5493,15.0606,88.5939,14.7928,88.5939,14.5249C88.6831,13.5428,88.7724,12.6054,88.817,11.6233C88.817,11.4447,88.8616,11.2215,88.6831,11.043",
      fill: "rgb(21,51,81)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x85",
      d: "M94.7518,17.6943C94.7964,18.9443,94.7071,21.1316,95.0641,21.4441C95.4211,21.7566,97.9645,21.7566,97.9645,21.7566C97.9645,21.7566,92.476,26.9349,92.1191,26.6671C91.7621,26.3992,86.8537,22.3816,87.9692,22.203C89.0848,21.9798,90.1557,22.0245,90.1111,21.4888C90.0665,20.9084,90.0665,20.3728,90.0218,19.7924",
      fill: "rgb(255,178,125)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("g", {
      id: "ef1gE7AqR8x86",
      opacity: "0.5"
    }, [
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x87",
        d: "M94.7518,17.6943C94.7964,18.9443,94.7071,21.1316,95.0641,21.4441C95.4211,21.7566,97.9645,21.7566,97.9645,21.7566C97.9645,21.7566,92.476,26.9349,92.1191,26.6671C91.7621,26.3992,86.8537,22.3816,87.9692,22.203C89.0848,21.9798,90.1557,22.0245,90.1111,21.4888C90.0665,20.9084,90.0665,20.3728,90.0218,19.7924",
        opacity: "0.5",
        fill: "rgb(255,178,125)",
        stroke: "none",
        "stroke-width": "1"
      })
    ]),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x88",
      d: "M102.784,36.5773L100.33,44.7019L99.4823,45.6393C99.4823,45.6393,92.0751,46.4875,89.844,46.5768C89.7548,46.5768,89.6655,46.5768,89.5763,46.5768C87.7022,46.6214,87.836,45.6393,87.836,45.6393C87.836,45.1929,87.7914,44.6572,87.7468,44.0323C87.5683,41.711,87.3006,38.4522,87.0328,37.1576C86.6759,35.6399,86.4974,35.0595,86.185,33.631C85.4711,30.4169,85.5157,29.792,84.8018,25.819L89.6209,21.9352C89.6209,21.9352,90.1117,23.4084,92.1197,23.453C94.8417,23.4977,95.6448,21.5781,95.6448,21.5781L102.204,25.9529L102.784,36.5773Z",
      fill: "rgb(255,255,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x89",
      d: "M94.8407,16.5783C94.7068,17.2033,94.4837,17.8283,94.2606,18.4532C93.8144,19.5693,93.1897,19.971,92.0295,19.971C91.2263,19.971,90.3785,20.0157,89.5753,20.0157C88.9506,20.0157,88.1474,20.0603,87.6566,19.6139C87.1657,19.1675,87.1211,18.4532,87.0319,17.8283C86.898,17.0694,86.7642,16.2659,86.6749,15.4623C86.4964,13.8999,86.4072,12.3821,86.4518,10.8197C86.4518,10.5965,86.4518,10.3733,86.4964,10.1948C86.4964,10.1055,86.541,10.0162,86.5857,9.97156C86.6749,9.88228,86.7642,9.88228,86.898,9.83764C88.4598,9.61444,90.0215,9.48051,91.5833,9.52515C92.6988,9.5698,93.859,9.70372,94.7068,10.3733C95.5993,11.0429,96.0009,12.1589,96.3578,13.1857C96.4024,13.3642,96.4471,13.5874,96.3132,13.6767",
      fill: "rgb(255,178,125)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x90",
      d: "M77.2148,72.7804C77.2148,72.7804,77.4826,74.3428,77.6611,74.8784C77.8842,75.4141,79.6244,74.9231,79.7137,74.566C79.8475,74.2088,79.1782,71.709,79.1782,71.709",
      fill: "rgb(237,156,128)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x91",
      d: "M80.3386,75.0127C80.4725,75.593,80.6956,76.6644,80.6956,76.6644L78.9554,77.4233L78.6876,77.1554C78.6876,77.1554,78.2414,77.6911,77.706,77.9143C77.3044,78.0929,76.4565,78.3161,76.0103,78.3607C74.4932,78.5393,73.3776,78.2268,73.2884,78.0482C72.9314,77.1554,74.9394,76.9322,75.341,76.8429C76.5012,76.5304,77.1259,75.5484,77.2597,74.9234C77.349,74.477,77.2151,74.3877,77.4829,74.3877C77.4829,74.3877,77.706,74.3877,77.9291,74.6109C78.2414,74.9234,78.7323,75.1019,79.1785,74.8787C79.4462,74.7895,79.6693,74.6109,79.8032,74.3877C79.7586,74.3877,80.2048,74.4323,80.3386,75.0127Z",
      fill: "rgb(31,58,113)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x92",
      d: "M89.7988,46.577L84.8458,52.5588C84.6673,52.6035,84.4442,52.6481,84.2658,52.6481C83.0163,52.8713,81.5884,52.9606,80.2052,53.0052C78.7327,53.0499,77.2601,52.9606,75.9661,52.782C76.3677,53.898,77.3048,55.2819,77.6617,56.8443C78.8219,61.978,79.2681,68.8526,79.5358,73.0934C79.5358,73.0934,78.9558,74.1648,77.1263,73.3613C74.4043,66.6206,69.6744,53.0052,69.7191,50.059C69.7191,49.3447,70.1207,48.7198,70.79,48.1394C70.8346,48.0948,70.8792,48.0948,70.8792,48.0501C71.6378,47.4252,72.7087,46.8895,74.0474,46.3984C74.092,46.3984,74.1366,46.3538,74.1812,46.3538C77.394,45.2378,82.0793,44.4789,87.2554,44.0771C87.3,44.0771,87.3447,44.0771,87.3893,44.0771C87.4785,44.0771,87.5678,44.0771,87.6124,44.0771C87.657,44.7021,87.7016,45.2824,87.7016,45.6842C87.7016,45.6842,87.6124,46.6663,89.4419,46.6217C89.6204,46.577,89.7096,46.577,89.7988,46.577Z",
      fill: "rgb(28,70,138)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("g", {
      id: "ef1gE7AqR8x93",
      opacity: "0.35"
    }, [
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x94",
        d: "M89.7986,46.5767L84.8456,52.5586C84.6671,52.6032,84.444,52.6478,84.2655,52.6478C82.8822,52.871,81.5436,53.005,80.2049,53.005C80.0711,52.7371,79.9372,52.4246,79.848,52.1122C79.7587,51.7104,79.8033,51.264,79.7587,50.8622C79.6248,50.0587,79.0448,49.3891,78.3308,48.9427C77.6169,48.5409,76.8137,48.3177,76.0105,48.1838C74.181,47.8713,71.1021,48.0499,70.7897,48.0945L70.7451,48.0945C70.7897,48.0499,70.8344,48.0052,70.879,48.0052C71.7714,47.3803,72.887,46.7999,74.0471,46.3535C74.0917,46.3535,74.1364,46.3089,74.181,46.3089C78.4647,44.7465,84.0424,44.2554,87.2552,44.0322C87.2998,44.0322,87.3444,44.0322,87.389,44.0322C87.4783,44.0322,87.5675,44.0322,87.6121,44.0322C87.6568,44.6572,87.7014,45.2375,87.7014,45.6393C87.7014,45.6393,87.6121,46.6214,89.4416,46.5767C89.6201,46.5767,89.7094,46.5767,89.7986,46.5767Z",
        opacity: "0.35",
        fill: "rgb(82,117,160)",
        stroke: "none",
        "stroke-width": "1"
      })
    ]),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x95",
      d: "M81.6777,76.3519C81.6777,76.3519,81.6777,77.9144,81.767,78.4947C81.8562,79.0304,83.6857,78.8518,83.8642,78.5393C84.0427,78.2268,83.8196,75.6377,83.8196,75.6377",
      fill: "rgb(237,156,128)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x96",
      d: "M84.3997,79.0745C84.4444,79.6549,84.4444,80.7709,84.4444,80.7709L82.6149,81.2173L82.3918,80.9048C82.3918,80.9048,81.8563,81.3512,81.3208,81.4851C80.9192,81.5744,80.0268,81.6637,79.5806,81.6637C78.0635,81.5744,76.9925,81.0834,76.9479,80.8602C76.7248,79.9227,78.7328,80.0566,79.179,80.012C80.3392,79.9227,81.1424,79.0746,81.3655,78.4496C81.5439,78.0032,81.4547,77.9139,81.6778,77.9585C81.6778,77.9585,81.9009,78.0032,82.0794,78.2264C82.3471,78.6281,82.7934,78.8514,83.2396,78.7174C83.5073,78.6282,83.775,78.5389,83.9535,78.3157C83.9089,78.3603,84.3551,78.4942,84.3997,79.0745Z",
      fill: "rgb(31,58,113)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x97",
      d: "M101.579,44.7019C102.293,46.3982,102.784,49.4338,102.07,50.7283C101.445,51.889,101.133,52.5586,100.062,52.9604C95.4212,54.4781,91.0036,53.8532,85.9168,53.1836C88.0586,59.0315,84.9351,71.5308,84.4442,76.843C82.4809,77.7358,81.3654,76.7983,81.3654,76.7983C81.5885,65.9954,79.1789,50.9069,80.6514,48.3177C81.5438,46.7553,92.1192,44.6572,92.2977,44.7019",
      fill: "rgb(28,70,138)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x98",
      d: "M93.5023,14.6587C93.5915,14.3016,94.1716,14.2569,94.4394,14.5248C94.7071,14.7926,94.7517,15.239,94.7517,15.5962C94.7517,16.0872,94.5286,16.5336,94.3055,16.9354C94.0378,17.3371,93.6808,17.5603,93.3238,17.2479C93.2792,17.9621,93.8593,18.4978,94.3501,18.5424C94.8409,18.5871,95.3318,18.2299,95.4656,17.7835C97.5629,18.5424,98.2322,15.5069,98.3214,13.9891C98.4107,12.7838,98.0091,11.3553,97.3844,10.3732C97.0274,9.83754,96.4919,9.39114,95.8672,9.21257C95.8226,8.45369,95.2425,7.78408,94.5732,7.38232C93.9039,6.98055,93.3238,6.84663,92.5652,6.66807C92.119,6.57879,90.825,6.93591,90.6019,7.38232C89.7095,6.89127,88.9063,7.38232,88.2369,7.42696C87.523,7.51624,86.7644,8.1412,87.0321,8.81081C85.9166,8.45369,84.7118,9.74826,85.0688,10.8643C85.3811,11.9803,86.9875,12.382,87.88,11.6678C88.1923,12.382,89.0401,12.7838,89.8433,12.7838C90.6465,12.7838,91.4051,12.4713,92.0744,12.0249C91.8513,12.4267,91.7621,13.007,91.9852,13.4534C92.2083,13.9445,92.3868,14.3016,93.1007,14.123C93.1007,14.123,93.0561,15.239,93.2792,15.1051C93.4131,15.1498,93.5023,14.6587,93.5023,14.6587Z",
      fill: "rgb(46,59,97)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x99",
      d: "M79.3572,41.9342C82.1684,37.8719,83.6855,34.6578,86.1397,30.3723L89.5756,21.8906C89.5756,21.8906,88.4154,21.9353,88.1923,21.9799C87.2107,22.0692,86.2736,22.2031,85.3365,22.5156C84.0425,23.0066,82.7039,23.8994,82.0345,25.1494C81.4544,26.2654,81.1421,27.5153,80.6513,28.7206C80.1158,30.0152,79.5357,31.3544,78.9556,32.649C77.8401,35.2381,76.6353,37.7826,75.6982,40.461",
      fill: "rgb(255,255,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x100",
      d: "M85.649,31.2201L85.2028,28.4971L81.8115,35.8627L82.9271,36.1306L85.649,31.2201Z",
      fill: "rgb(176,217,239)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x101",
      d: "M101.846,25.8188C102.025,29.1668,102.025,32.5595,101.846,35.9075C101.668,39.3002,101.088,42.6036,100.775,45.9516C100.775,46.1302,101.043,46.1748,101.088,45.9963C101.846,42.8268,102.069,39.3895,102.248,36.1307C102.426,32.6934,102.382,29.2561,102.159,25.8188C102.203,25.5956,101.846,25.5956,101.846,25.8188Z",
      fill: "rgb(0,0,0)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x102",
      d: "M71.5649,46.3828L97.624,46.3828L97.624,45.4454L71.5649,45.4454L71.5649,46.3828Z",
      fill: "rgb(170,189,226)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x103",
      d: "M66.9526,46.3536L87.7909,46.3536L84.0427,34.1668C83.8196,33.4972,83.1949,33.0508,82.5256,33.0508L64.2753,33.0508C63.5613,33.0508,63.0705,33.7204,63.2936,34.39L66.9526,46.3536Z",
      fill: "rgb(170,189,226)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x104",
      d: "M66.6848,46.3536L87.2109,46.3536L83.4626,34.1668C83.2395,33.4972,82.6148,33.0508,81.9455,33.0508L63.6952,33.0508C62.9812,33.0508,62.4904,33.7204,62.7135,34.39L66.2833,46.0858C66.3279,46.2643,66.5064,46.3536,66.6848,46.3536Z",
      fill: "rgb(225,232,249)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x105",
      d: "M74.1373,41.9345C75.2955,41.9345,76.2345,40.9951,76.2345,39.8364C76.2345,38.6776,75.2955,37.7383,74.1373,37.7383C72.979,37.7383,72.04,38.6776,72.04,39.8364C72.04,40.9951,72.979,41.9345,74.1373,41.9345Z",
      fill: "rgb(170,189,226)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x106",
      d: "M99.0361,28.0057C97.9652,32.8715,97.6082,38.4515,97.3405,41.9335C93.3245,42.2459,92.1644,43.7637,88.5054,45.4154C88.5054,45.4154,85.605,44.9244,85.2926,46.0404C85.1141,46.6654,88.6839,47.201,88.6839,47.201C92.1197,47.201,100.375,45.594,100.999,45.4601C101.624,45.2815,104.123,32.9161,104.168,26.7111C104.168,25.8183,104.168,24.8808,103.588,24.1666C103.275,23.8095,102.874,23.5416,102.472,23.363C100.062,22.1131,98.2775,21.8006,95.6002,21.6221",
      fill: "rgb(176,217,239)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x107",
      d: "M88.9953,46.1751C88.5937,45.684,87.8351,45.5947,87.2104,45.5947C86.7196,45.5947,86.2288,45.6394,85.7825,45.7286C85.5594,45.7733,85.3363,45.8179,85.2917,46.0411C85.2471,46.2643,86.3626,46.0411,86.8981,46.2197C85.7825,46.309,84.667,46.3536,83.5515,46.309C83.4176,46.309,83.2837,46.309,83.1499,46.3536C83.016,46.3983,82.9268,46.5322,82.9268,46.6661C82.9268,46.7554,83.016,46.8447,83.0606,46.9339C83.373,47.2018,83.7746,47.3357,84.2208,47.3803C85.9164,47.6928,87.7013,47.6482,89.3077,46.9339",
      fill: "rgb(237,156,128)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x108",
      d: "M99.0354,28.0061C98.9462,33.1844,98.1876,37.9162,98.3215,43.0945C94.3055,43.407,92.2529,44.1659,88.5493,45.8176C88.5493,45.8176,88.3262,46.5319,88.6832,47.1568C88.9509,47.2461,100.731,46.7551,101.713,45.8622C102.605,45.0587,104.122,32.8719,104.212,26.6222C104.212,25.7294,104.212,24.792,103.631,24.0777C103.319,23.7206,102.918,23.4527,102.516,23.2742C100.106,22.0242,98.3215,21.7118,95.6442,21.5332",
      fill: "rgb(255,255,255)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x109",
      d: "M87.1665,14.4355C87.1665,14.4355,85.9171,16.6229,86.0956,16.8908C86.2741,17.1586,87.7466,16.8908,87.7466,16.8908",
      fill: "rgb(255,178,125)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("g", { id: "ef1gE7AqR8x110" }, [
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x111",
        d: "M112.372,134.445L112.372,128.843C112.372,127.547,111.308,126.482,110.012,126.482L108.254,126.482C107.143,126.482,106.171,125.788,105.801,124.723C105.523,123.936,105.199,123.149,104.829,122.408C104.367,121.39,104.552,120.232,105.338,119.445L106.588,118.196C107.513,117.27,107.513,115.788,106.588,114.862L102.654,110.927C101.729,110.001,100.248,110.001,99.3226,110.927L98.0732,112.177C97.2865,112.964,96.0834,113.149,95.1116,112.687C94.3712,112.316,93.5846,111.992,92.7979,111.714C91.7336,111.344,91.0395,110.372,91.0395,109.261L91.0395,107.502C91.0395,106.205,89.9751,105.141,88.6795,105.141L83.0802,105.141C81.7846,105.141,80.7202,106.205,80.7202,107.502L80.7202,109.261C80.7202,110.372,80.0261,111.344,78.9618,111.714C78.1751,111.992,77.3885,112.316,76.6481,112.687C75.63,113.149,74.4732,112.964,73.6865,112.177L72.4371,110.927C71.5116,110.001,70.0308,110.001,69.1053,110.927L65.172,114.862C64.2465,115.788,64.2465,117.27,65.172,118.196L66.4214,119.445C67.2081,120.232,67.3932,121.436,66.9304,122.408C66.5602,123.149,66.2363,123.936,65.9587,124.723C65.5885,125.788,64.6167,126.482,63.5061,126.482L61.7477,126.482C60.452,126.482,59.3877,127.547,59.3877,128.843L59.3877,134.445C59.3877,135.741,60.452,136.806,61.7477,136.806L63.5061,136.806C64.6167,136.806,65.5885,137.5,65.9587,138.565C66.2363,139.352,66.5602,140.139,66.9304,140.88C67.3932,141.898,67.2081,143.055,66.4214,143.842L65.172,145.092C64.2465,146.018,64.2465,147.5,65.172,148.425L69.1053,152.36C70.0308,153.286,71.5116,153.286,72.4371,152.36L73.6865,151.11C74.4732,150.323,75.6763,150.138,76.6481,150.601C77.3885,150.972,78.1751,151.296,78.9618,151.573C80.0261,151.944,80.7202,152.916,80.7202,154.027L80.7202,155.786C80.7202,157.082,81.7846,158.147,83.0802,158.147L88.6795,158.147C89.9751,158.147,91.0395,157.082,91.0395,155.786L91.0395,154.027C91.0395,152.916,91.7336,151.944,92.7979,151.573C93.5846,151.296,94.3712,150.972,95.1116,150.601C96.1297,150.138,97.2865,150.323,98.0732,151.11L99.3226,152.36C100.248,153.286,101.729,153.286,102.654,152.36L106.588,148.425C107.513,147.5,107.513,146.018,106.588,145.092L105.338,143.842C104.552,143.055,104.367,141.852,104.829,140.88C105.199,140.139,105.523,139.352,105.801,138.565C106.171,137.5,107.143,136.806,108.254,136.806L110.012,136.806C111.354,136.806,112.372,135.741,112.372,134.445ZM87.0136,144.352C79.1932,144.953,72.6685,138.472,73.3163,130.649C73.8253,124.491,78.7767,119.492,84.9775,118.982C92.7979,118.381,99.3226,124.862,98.6748,132.685C98.1657,138.889,93.1681,143.889,87.0136,144.352Z",
        fill: "rgb(46,96,173)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x112",
        d: "M120.193,135.278L120.193,128.057C120.193,126.39,118.851,125.001,117.139,125.001L114.871,125.001C113.437,125.001,112.141,124.075,111.678,122.733C111.308,121.714,110.892,120.696,110.429,119.724C109.781,118.427,110.059,116.9,111.077,115.881L112.65,114.307C113.853,113.104,113.853,111.206,112.65,110.002L107.514,104.863C106.31,103.66,104.413,103.66,103.21,104.863L101.637,106.437C100.619,107.456,99.0917,107.734,97.796,107.085C96.8242,106.622,95.8062,106.206,94.7881,105.835C93.4462,105.373,92.5207,104.076,92.5207,102.641L92.5207,100.373C92.5207,98.7062,91.1787,97.3174,89.4666,97.3174L82.2478,97.3174C80.5819,97.3174,79.1936,98.6599,79.1936,100.373L79.1936,102.641C79.1936,104.076,78.2681,105.373,76.9262,105.835C75.9081,106.206,74.8901,106.622,73.9183,107.085C72.6227,107.734,71.0956,107.456,70.0776,106.437L68.5042,104.863C67.3011,103.66,65.4038,103.66,64.2007,104.863L59.0642,110.002C57.8611,111.206,57.8611,113.104,59.0642,114.307L60.6376,115.881C61.6556,116.9,61.9332,118.427,61.2854,119.724C60.8227,120.696,60.4062,121.714,60.036,122.733C59.5733,124.075,58.2776,125.001,56.8431,125.001L54.5756,125.001C52.9097,125.001,51.5215,126.344,51.5215,128.057L51.5215,135.278C51.5215,136.945,52.8634,138.334,54.5756,138.334L56.8431,138.334C58.2776,138.334,59.5733,139.26,60.036,140.602C60.4062,141.621,60.8227,142.639,61.2854,143.611C61.9332,144.908,61.6556,146.435,60.6376,147.454L59.0642,149.028C57.8611,150.231,57.8611,152.129,59.0642,153.333L64.2007,158.472C65.4038,159.675,67.3011,159.675,68.5042,158.472L70.0776,156.898C71.0956,155.879,72.6227,155.601,73.9183,156.25C74.8901,156.712,75.9081,157.129,76.9262,157.499C78.2681,157.962,79.1936,159.259,79.1936,160.694L79.1936,162.962C79.1936,164.629,80.5356,166.018,82.2478,166.018L89.6054,166.018C91.2713,166.018,92.6595,164.675,92.6595,162.962L92.6595,160.694C92.6595,159.259,93.585,157.962,94.927,157.499C95.945,157.129,96.963,156.712,97.9348,156.25C99.2305,155.601,100.758,155.879,101.776,156.898L103.349,158.472C104.552,159.675,106.449,159.675,107.652,158.472L112.789,153.333C113.992,152.129,113.992,150.231,112.789,149.028L111.216,147.454C110.198,146.435,109.92,144.908,110.568,143.611C111.03,142.639,111.447,141.621,111.817,140.602C112.28,139.26,113.576,138.334,115.01,138.334L117.278,138.334C118.851,138.334,120.193,136.991,120.193,135.278ZM87.2917,148.102C77.1113,148.889,68.7356,140.463,69.5223,130.325C70.1701,122.316,76.6485,115.835,84.6077,115.233C94.7881,114.446,103.164,122.872,102.377,133.01C101.776,141.019,95.2972,147.5,87.2917,148.102Z",
        fill: "rgb(2,161,209)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x113",
        d: "M85.9501,153.657C98.0895,153.657,107.93,143.812,107.93,131.667C107.93,119.523,98.0895,109.678,85.9501,109.678C73.8107,109.678,63.9697,119.523,63.9697,131.667C63.9697,143.812,73.8107,153.657,85.9501,153.657Z",
        fill: "none",
        stroke: "rgb(134,200,255)",
        "stroke-width": "6.0487",
        "stroke-miterlimit": "10"
      })
    ]),
    /*#__PURE__*/_createVNode("ellipse", {
      id: "ef1gE7AqR8x114",
      rx: "17.0352",
      ry: "17.0514",
      transform: "matrix(1 0 0 1 85.8399 131.521)",
      fill: "rgb(235,245,252)",
      stroke: "none",
      "stroke-width": "1"
    }),
    /*#__PURE__*/_createVNode("g", { id: "ef1gE7AqR8x115" }, [
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x116",
        d: "M134.983,117.541C131.188,116.477,128.273,113.282,128.042,109.301C128.042,109.116,128.042,108.931,128.042,108.746C128.042,108.699,128.042,108.653,128.042,108.56C128.042,108.514,128.042,108.468,128.042,108.375C128.042,108.19,128.042,108.005,128.042,107.82C128.273,103.885,131.142,100.644,134.983,99.5795C149.328,95.5982,159.832,82.4507,159.832,66.8497C159.832,64.7665,159.647,62.6832,159.277,60.6926C159.231,60.3685,159.138,59.9982,159.092,59.6741C159.046,59.4427,158.999,59.1649,158.907,58.9334L158.907,58.8871C158.861,58.7483,158.861,58.6557,158.814,58.5168C158.768,58.2853,158.675,58.0539,158.629,57.7761C158.537,57.4057,158.444,57.0354,158.305,56.665L157.148,56.665C157.195,56.8039,157.241,56.8965,157.241,57.0354L157.241,57.0817C157.287,57.2669,157.38,57.4983,157.426,57.6835C157.472,57.8224,157.519,57.9613,157.519,58.1002C157.565,58.3316,157.657,58.5168,157.704,58.7483C157.75,58.8871,157.796,59.026,157.796,59.1649C157.843,59.3964,157.889,59.5816,157.935,59.813C157.935,59.9056,157.981,59.9519,157.981,60.0445C157.981,60.0908,157.981,60.0908,157.981,60.1371C158.028,60.3685,158.074,60.6463,158.12,60.8778C158.49,62.8221,158.675,64.8128,158.675,66.8034C158.675,81.5249,148.773,94.5334,134.613,98.4684C130.217,99.6721,127.116,103.376,126.885,107.681C126.885,107.912,126.885,108.098,126.885,108.329C126.885,108.375,126.885,108.468,126.885,108.514C126.885,108.56,126.885,108.653,126.885,108.699C126.885,108.931,126.885,109.116,126.885,109.347C127.116,113.653,130.217,117.356,134.613,118.56C148.773,122.495,158.675,135.504,158.675,150.225C158.675,152.262,158.49,154.253,158.12,156.151C157.611,158.882,156.778,161.567,155.575,164.113L96.2049,164.113C95.0018,161.567,94.1688,158.882,93.6598,156.151C93.2896,154.206,93.1045,152.216,93.1045,150.225C93.1045,135.504,103.007,122.495,117.167,118.56C121.563,117.356,124.664,113.653,124.895,109.347C124.895,109.116,124.895,108.931,124.895,108.699C124.895,108.653,124.895,108.607,124.895,108.514C124.895,108.468,124.895,108.422,124.895,108.329C124.895,108.098,124.895,107.912,124.895,107.681C124.664,103.376,121.563,99.6721,117.167,98.4684C103.007,94.5334,93.1045,81.5249,93.1045,66.8034C93.1045,64.7665,93.2896,62.7758,93.6598,60.8778C93.7061,60.5537,93.7986,60.1834,93.8449,59.8593C93.8449,59.8593,93.8449,59.8593,93.8449,59.813C93.9374,59.489,93.9837,59.1649,94.0763,58.7946L94.0763,58.7483C94.1225,58.5168,94.2151,58.239,94.2614,58.0076L94.2614,57.9613C94.2614,57.8687,94.3076,57.7761,94.3539,57.6835C94.4002,57.4983,94.4465,57.3132,94.4927,57.128L94.4927,57.0817C94.539,56.9428,94.5853,56.8502,94.5853,56.7113L93.4284,56.7113C93.3359,57.0817,93.197,57.452,93.1045,57.8224C93.012,58.0539,92.9657,58.2853,92.9194,58.5631C92.8731,58.702,92.8731,58.7946,92.8269,58.9334L92.8269,58.9797C92.7806,59.2112,92.7343,59.489,92.6418,59.7204C92.5492,60.0445,92.5029,60.3686,92.4567,60.7389C92.0865,62.7295,91.9014,64.7665,91.9014,66.896C91.9014,82.497,102.406,95.6445,116.751,99.6258C120.545,100.691,123.461,103.885,123.692,107.866C123.692,108.051,123.692,108.236,123.692,108.422C123.692,108.468,123.692,108.56,123.692,108.607C123.692,108.653,123.692,108.746,123.692,108.792C123.692,108.977,123.692,109.162,123.692,109.347C123.461,113.282,120.592,116.523,116.751,117.588C102.406,121.569,91.9014,134.717,91.9014,150.318C91.9014,152.401,92.0865,154.484,92.4567,156.475C93.012,159.623,94.03,162.585,95.4182,165.363L156.269,165.363C157.657,162.585,158.629,159.623,159.231,156.475C159.601,154.484,159.786,152.447,159.786,150.318C159.832,134.67,149.328,121.523,134.983,117.541Z",
        opacity: "0.2",
        fill: "rgb(2,161,209)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x117",
        d: "M158.722,150.272C158.722,152.309,158.537,154.299,158.166,156.197C157.657,158.929,156.824,161.614,155.621,164.16L96.2049,164.16C95.0017,161.614,94.1688,158.929,93.6598,156.197C93.2896,154.253,93.1045,152.262,93.1045,150.272C93.1045,135.55,103.007,122.542,117.167,118.607C121.563,117.403,124.664,113.7,124.895,109.394C124.895,109.163,124.895,108.978,124.895,108.746C124.895,108.7,124.895,108.654,124.895,108.561C124.895,108.515,124.895,108.468,124.895,108.376C124.895,108.144,124.895,107.959,124.895,107.728C124.664,103.422,121.563,99.7189,117.167,98.5153C103.007,94.5803,93.1045,81.5717,93.1045,66.8503C93.1045,64.8133,93.2896,62.8227,93.6598,60.9247C93.7061,60.6006,93.7986,60.2302,93.8449,59.9062C93.8449,59.9062,93.8449,59.9062,93.8449,59.8599C93.9374,59.5358,93.9837,59.2118,94.0763,58.8414L94.0763,58.7951C94.1688,58.5174,94.2151,58.2396,94.3076,57.9618C94.4002,57.6841,94.4465,57.4063,94.539,57.1286C94.5853,56.9897,94.6316,56.8508,94.6778,56.7119L157.148,56.7119C157.195,56.8508,157.241,56.9897,157.287,57.1286C157.334,57.3137,157.426,57.5452,157.472,57.7304C157.519,57.8693,157.565,58.0081,157.565,58.147C157.611,58.3785,157.704,58.5637,157.75,58.7951C157.796,58.934,157.843,59.0729,157.843,59.2118C157.889,59.4433,157.935,59.6284,157.981,59.8599C157.981,59.9525,158.028,60.0451,158.028,60.184C158.074,60.4154,158.12,60.6932,158.166,60.9247C158.537,62.869,158.722,64.8596,158.722,66.8503C158.722,81.5717,148.819,94.5803,134.659,98.5153C130.263,99.7189,127.163,103.422,126.931,107.728C126.931,107.959,126.931,108.144,126.931,108.376C126.931,108.422,126.931,108.515,126.931,108.561C126.931,108.607,126.931,108.7,126.931,108.746C126.931,108.978,126.931,109.163,126.931,109.394C127.163,113.7,130.263,117.403,134.659,118.607C148.865,122.542,158.722,135.55,158.722,150.272Z",
        fill: "rgb(255,255,255)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x118",
        d: "M158.722,150.272C158.722,152.309,158.537,154.299,158.166,156.197C157.657,158.929,156.824,161.614,155.621,164.16L96.2049,164.16C95.0017,161.614,94.1688,158.929,93.6598,156.197C93.2896,154.253,93.1045,152.262,93.1045,150.272C93.1045,135.55,103.007,122.542,117.167,118.607C121.563,117.403,124.664,113.7,124.895,109.394C124.895,109.163,124.895,108.978,124.895,108.746C124.895,108.7,124.895,108.654,124.895,108.561C124.895,108.515,124.895,108.468,124.895,108.376C124.895,108.144,124.895,107.959,124.895,107.728C124.664,103.422,121.563,99.7189,117.167,98.5153C103.007,94.5803,93.1045,81.5717,93.1045,66.8503C93.1045,64.8133,93.2896,62.8227,93.6598,60.9247C93.7061,60.6006,93.7986,60.2302,93.8449,59.9062C93.8449,59.9062,93.8449,59.9062,93.8449,59.8599C93.9374,59.5358,93.9837,59.2118,94.0763,58.8414L94.0763,58.7951C94.1688,58.5174,94.2151,58.2396,94.3076,57.9618C94.4002,57.6841,94.4465,57.4063,94.539,57.1286C94.5853,56.9897,94.6316,56.8508,94.6778,56.7119L157.148,56.7119C157.195,56.8508,157.241,56.9897,157.287,57.1286C157.334,57.3137,157.426,57.5452,157.472,57.7304C157.519,57.8693,157.565,58.0081,157.565,58.147C157.611,58.3785,157.704,58.5637,157.75,58.7951C157.796,58.934,157.843,59.0729,157.843,59.2118C157.889,59.4433,157.935,59.6284,157.981,59.8599C157.981,59.9525,158.028,60.0451,158.028,60.184C158.074,60.4154,158.12,60.6932,158.166,60.9247C158.537,62.869,158.722,64.8596,158.722,66.8503C158.722,81.5717,148.819,94.5803,134.659,98.5153C130.263,99.7189,127.163,103.422,126.931,107.728C126.931,107.959,126.931,108.144,126.931,108.376C126.931,108.422,126.931,108.515,126.931,108.561C126.931,108.607,126.931,108.7,126.931,108.746C126.931,108.978,126.931,109.163,126.931,109.394C127.163,113.7,130.263,117.403,134.659,118.607C148.865,122.542,158.722,135.55,158.722,150.272Z",
        opacity: "0.5",
        fill: "rgb(215,236,250)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x119",
        d: "M98.8418,86.247C98.8418,86.247,104.025,94.7187,116.426,98.6537C119.619,99.5796,120.683,100.274,122.488,101.987C124.339,103.653,124.941,106.663,124.894,108.977C124.848,110.783,125.912,137.402,125.912,140.689C125.912,143.79,126.329,141.476,126.236,140.827C126.56,122.032,126.93,108.19,126.93,108.19C126.93,108.19,128.041,102.265,129.799,101.478C131.558,100.644,137.851,97.7278,140.443,96.9871C143.034,96.2464,149.281,90.5523,149.281,90.5523C149.281,90.5523,157.194,79.2566,157.703,77.7752C158.166,76.3401,154.14,76.2012,154.14,76.2012L98.8418,86.247Z",
        fill: "rgb(247,193,55)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x120",
        d: "M128.784,86.8108C145.397,84.2032,158.428,79.3046,157.889,75.8695C157.35,72.4344,143.446,71.7636,126.833,74.3713C110.22,76.9789,97.1897,81.8775,97.7284,85.3126C98.2671,88.7476,112.171,89.4185,128.784,86.8108Z",
        fill: "rgb(253,207,51)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("g", {
        id: "ef1gE7AqR8x121",
        opacity: "0.5"
      }, [
        /*#__PURE__*/_createVNode("g", {
          id: "ef1gE7AqR8x122",
          opacity: "0.5"
        }, [
          /*#__PURE__*/_createVNode("path", {
            id: "ef1gE7AqR8x123",
            d: "M116.981,94.3948C116.611,94.3948,116.241,94.3486,115.917,94.2097C113.557,93.3764,111.336,92.3579,109.392,91.108C107.865,90.1358,107.356,88.0989,108.328,86.5249C109.3,84.9972,111.336,84.4879,112.909,85.4601C114.436,86.4323,116.195,87.2193,118.092,87.9137C119.804,88.5155,120.73,90.4136,120.128,92.1264C119.665,93.5153,118.37,94.3948,116.981,94.3948Z",
            opacity: "0.5",
            fill: "rgb(255,255,255)",
            stroke: "none",
            "stroke-width": "1"
          })
        ]),
        /*#__PURE__*/_createVNode("g", {
          id: "ef1gE7AqR8x124",
          opacity: "0.5"
        }, [
          /*#__PURE__*/_createVNode("path", {
            id: "ef1gE7AqR8x125",
            d: "M104.025,84.6273C102.914,84.6273,101.85,84.0717,101.248,83.0996C95.4638,74.026,96.9446,63.8413,97.0371,63.4247C97.3148,61.6192,99.0269,60.3693,100.832,60.647C102.636,60.9248,103.886,62.5914,103.608,64.3968C103.608,64.5357,102.498,72.6372,106.847,79.5349C107.819,81.0626,107.356,83.1459,105.829,84.118C105.274,84.4421,104.672,84.6273,104.025,84.6273Z",
            opacity: "0.5",
            fill: "rgb(255,255,255)",
            stroke: "none",
            "stroke-width": "1"
          })
        ])
      ]),
      /*#__PURE__*/_createVNode("g", {
        id: "ef1gE7AqR8x126",
        opacity: "0.5"
      }, [
        /*#__PURE__*/_createVNode("g", {
          id: "ef1gE7AqR8x127",
          opacity: "0.5"
        }, [
          /*#__PURE__*/_createVNode("path", {
            id: "ef1gE7AqR8x128",
            d: "M116.981,122.402C116.611,122.402,116.241,122.449,115.917,122.588C113.557,123.421,111.336,124.439,109.392,125.689C107.865,126.661,107.356,128.698,108.328,130.272C109.3,131.8,111.336,132.309,112.909,131.337C114.436,130.365,116.195,129.578,118.092,128.883C119.804,128.282,120.73,126.384,120.128,124.671C119.665,123.282,118.37,122.402,116.981,122.402Z",
            opacity: "0.5",
            fill: "rgb(255,255,255)",
            stroke: "none",
            "stroke-width": "1"
          })
        ]),
        /*#__PURE__*/_createVNode("g", {
          id: "ef1gE7AqR8x129",
          opacity: "0.5"
        }, [
          /*#__PURE__*/_createVNode("path", {
            id: "ef1gE7AqR8x130",
            d: "M104.025,132.17C102.914,132.17,101.85,132.725,101.248,133.698C95.4638,142.771,96.9446,152.956,97.0371,153.373C97.3148,155.178,99.0269,156.428,100.832,156.15C102.636,155.872,103.886,154.206,103.608,152.4C103.608,152.261,102.498,144.16,106.847,137.262C107.819,135.735,107.356,133.651,105.829,132.679C105.274,132.355,104.672,132.17,104.025,132.17Z",
            opacity: "0.5",
            fill: "rgb(255,255,255)",
            stroke: "none",
            "stroke-width": "1"
          })
        ])
      ]),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x131",
        d: "M134.983,117.541C131.188,116.477,128.273,113.282,128.042,109.301C128.042,109.116,128.042,108.931,128.042,108.746C128.042,108.699,128.042,108.653,128.042,108.56C128.042,108.514,128.042,108.468,128.042,108.375C128.042,108.19,128.042,108.005,128.042,107.82C128.273,103.885,131.142,100.644,134.983,99.5795C149.328,95.5982,159.832,82.4507,159.832,66.8497C159.832,64.7665,159.647,62.6832,159.277,60.6926C159.231,60.3685,159.138,59.9982,159.092,59.6741C159.046,59.4427,158.999,59.1649,158.907,58.9334L158.907,58.8871C158.861,58.7483,158.861,58.6557,158.814,58.5168C158.768,58.2853,158.675,58.0539,158.629,57.7761C158.537,57.4057,158.444,57.0354,158.305,56.665L157.148,56.665C157.195,56.7576,157.241,56.8965,157.241,57.0354L157.241,57.0817C157.287,57.2669,157.38,57.4983,157.426,57.6835C157.472,57.8224,157.519,57.9613,157.519,58.1002C157.565,58.3316,157.657,58.5168,157.704,58.7483C157.75,58.8871,157.796,59.026,157.796,59.1649C157.843,59.3964,157.889,59.5816,157.935,59.813C157.935,59.9056,157.981,59.9519,157.981,60.0445C157.981,60.0908,157.981,60.0908,157.981,60.1371C158.028,60.3685,158.074,60.6463,158.12,60.8778C158.49,62.8221,158.675,64.8128,158.675,66.8034C158.675,81.5249,148.773,94.5334,134.613,98.4684C130.217,99.6721,127.116,103.376,126.885,107.681C126.885,107.912,126.885,108.098,126.885,108.329C126.885,108.375,126.885,108.468,126.885,108.514C126.885,108.56,126.885,108.653,126.885,108.699C126.885,108.931,126.885,109.116,126.885,109.347C127.116,113.653,130.217,117.356,134.613,118.56C148.773,122.495,158.675,135.504,158.675,150.225C158.675,152.262,158.49,154.253,158.12,156.151C157.611,158.882,156.778,161.567,155.575,164.113L96.2049,164.113C95.0018,161.567,94.1688,158.882,93.6598,156.151C93.2896,154.206,93.1045,152.216,93.1045,150.225C93.1045,135.504,103.007,122.495,117.167,118.56C121.563,117.356,124.664,113.653,124.895,109.347C124.895,109.116,124.895,108.931,124.895,108.699C124.895,108.653,124.895,108.607,124.895,108.514C124.895,108.468,124.895,108.422,124.895,108.329C124.895,108.098,124.895,107.912,124.895,107.681C124.664,103.376,121.563,99.6721,117.167,98.4684C103.007,94.5334,93.1045,81.5249,93.1045,66.8034C93.1045,64.7665,93.2896,62.7758,93.6598,60.8778C93.7061,60.5537,93.7986,60.1834,93.8449,59.8593C93.8449,59.8593,93.8449,59.8593,93.8449,59.813C93.9374,59.489,93.9837,59.1649,94.0763,58.7946L94.0763,58.7483C94.1225,58.5168,94.2151,58.239,94.2614,58.0076L94.2614,57.9613C94.3076,57.8687,94.3076,57.7761,94.3539,57.6835C94.4002,57.4983,94.4465,57.3132,94.4927,57.128L94.4927,57.0817C94.539,56.9428,94.5853,56.8502,94.5853,56.7113L93.4284,56.7113C93.3359,57.0817,93.197,57.452,93.1045,57.8224C93.012,58.0539,92.9657,58.2853,92.9194,58.5631C92.8731,58.702,92.8731,58.7946,92.8269,58.9334L92.8269,58.9797C92.7806,59.2112,92.7343,59.489,92.6418,59.7204C92.5492,60.0445,92.5029,60.3686,92.4567,60.7389C92.0865,62.7295,91.9014,64.7665,91.9014,66.896C91.9014,82.497,102.406,95.6445,116.751,99.6258C120.545,100.691,123.461,103.885,123.692,107.866C123.692,108.051,123.692,108.236,123.692,108.422C123.692,108.468,123.692,108.56,123.692,108.607C123.692,108.653,123.692,108.746,123.692,108.792C123.692,108.977,123.692,109.162,123.692,109.347C123.461,113.282,120.592,116.523,116.751,117.588C102.406,121.569,91.9014,134.717,91.9014,150.318C91.9014,152.401,92.0865,154.484,92.4567,156.475C93.012,159.623,94.03,162.585,95.4182,165.363L156.269,165.363C157.657,162.585,158.629,159.623,159.231,156.475C159.601,154.484,159.786,152.447,159.786,150.318C159.832,134.67,149.328,121.523,134.983,117.541Z",
        fill: "rgb(237,247,253)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x132",
        d: "M168.208,163.466C168.208,165.225,166.773,166.66,165.015,166.66L86.857,166.66C85.0986,166.66,83.6641,165.225,83.6641,163.466C83.6641,161.707,85.0986,160.271,86.857,160.271L165.015,160.271C166.773,160.271,168.208,161.707,168.208,163.466Z",
        fill: "rgb(2,161,209)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x133",
        d: "M150.433,77.9423C151.283,77.7623,151.929,77.4137,151.876,77.1636C151.823,76.9134,151.091,76.8565,150.241,77.0365C149.391,77.2164,148.745,77.5651,148.798,77.8152C148.851,78.0653,149.583,78.1222,150.433,77.9423Z",
        fill: "rgb(247,193,55)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x134",
        d: "M149.003,80.6305C149.553,80.5141,149.956,80.2169,149.903,79.9668C149.85,79.7167,149.361,79.6083,148.811,79.7247C148.261,79.8412,147.858,80.1383,147.911,80.3884C147.964,80.6386,148.453,80.7469,149.003,80.6305Z",
        fill: "rgb(247,193,55)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x135",
        d: "M146.503,79.8883C147.053,79.7719,147.456,79.4747,147.403,79.2246C147.35,78.9745,146.861,78.8661,146.311,78.9825C145.761,79.099,145.358,79.3961,145.411,79.6463C145.464,79.8964,145.953,80.0048,146.503,79.8883Z",
        fill: "rgb(247,193,55)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x136",
        d: "M129.612,81.792C129.912,81.7285,130.133,81.5756,130.107,81.4506C130.081,81.3255,129.816,81.2756,129.516,81.3391C129.216,81.4026,128.994,81.5555,129.021,81.6805C129.047,81.8056,129.312,81.8555,129.612,81.792Z",
        fill: "rgb(247,193,55)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x137",
        d: "M142.982,77.7178C143.282,77.6543,143.504,77.5014,143.477,77.3763C143.451,77.2513,143.186,77.2014,142.886,77.2649C142.586,77.3284,142.364,77.4813,142.391,77.6063C142.417,77.7314,142.682,77.7813,142.982,77.7178Z",
        fill: "rgb(247,193,55)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x138",
        d: "M138.123,82.4004C138.423,82.3369,138.645,82.184,138.619,82.059C138.592,81.9339,138.328,81.884,138.028,81.9475C137.728,82.011,137.506,82.1639,137.532,82.2889C137.559,82.414,137.823,82.4639,138.123,82.4004Z",
        fill: "rgb(247,193,55)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x139",
        d: "M131.695,85.4902C131.995,85.4267,132.217,85.2739,132.19,85.1488C132.164,85.0237,131.899,84.9738,131.599,85.0373C131.299,85.1009,131.077,85.2537,131.104,85.3788C131.13,85.5039,131.395,85.5538,131.695,85.4902Z",
        fill: "rgb(247,193,55)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x140",
        d: "M126.283,137.309L126.051,137.217L125.82,137.309C125.82,137.309,123.876,152.586,102.914,160.271C114.39,160.271,121.655,160.271,126.19,160.271C132.298,160.271,133.502,160.271,133.502,160.271C136.88,160.271,141.877,160.271,149.189,160.271C128.226,152.586,126.283,137.309,126.283,137.309Z",
        fill: "rgb(247,193,55)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x141",
        d: "M125.912,60.2297C143.853,60.2297,158.397,58.8411,158.397,57.1281C158.397,55.415,143.853,54.0264,125.912,54.0264C107.972,54.0264,93.4277,55.415,93.4277,57.1281C93.4277,58.8411,107.972,60.2297,125.912,60.2297Z",
        fill: "rgb(185,219,239)",
        stroke: "none",
        "stroke-width": "1"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "ef1gE7AqR8x142",
        d: "M164.968,52.4062L86.857,52.4062C85.9778,52.4062,85.1448,52.7766,84.5896,53.3321C83.988,53.9339,83.6641,54.7209,83.6641,55.6005C83.6641,57.3597,85.0986,58.7948,86.857,58.7948L93.5668,58.7948L94.7237,58.7948L157.194,58.7948L158.351,58.7948L165.061,58.7948C166.819,58.7948,168.254,57.3597,168.254,55.6005C168.208,53.8414,166.773,52.4062,164.968,52.4062Z",
        fill: "rgb(2,161,209)",
        stroke: "none",
        "stroke-width": "1"
      })
    ]),
    /*#__PURE__*/_createVNode("path", {
      id: "ef1gE7AqR8x143",
      d: "M224.18,168.355L15.4909,168.355C14.7309,168.355,14.127,167.905,14.127,167.355C14.127,166.798,14.7413,166.355,15.4909,166.355L224.18,166.355C224.94,166.355,225.544,166.806,225.544,167.355C225.544,167.905,224.94,168.355,224.18,168.355Z",
      fill: "rgb(67,96,168)",
      stroke: "none",
      "stroke-width": "1"
    })
  ]),
  /*#__PURE__*/_createVNode("clipPath", { id: "ef1gE7AqR8x144" }, [
    /*#__PURE__*/_createVNode("rect", {
      id: "ef1gE7AqR8x145",
      width: "236",
      height: "178",
      rx: "0",
      ry: "0",
      fill: "rgb(255,255,255)",
      stroke: "none",
      "stroke-width": "1"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}